import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Preview.svg",
  "use": "Preview.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Preview.svg\"><path d=\"M42.01,50.0208a2,2,0,0,1,0,4h-20a2,2,0,0,1,0-4Zm14-6a4,4,0,0,1-4,4h-40a4,4,0,0,1-4-4v-26a4,4,0,0,1,4-4h40a4,4,0,0,1,4,4ZM42.4577,30.1263l-16-8a1,1,0,0,0-1.4472.8945v16a1,1,0,0,0,1.4472.8944l16-8a1,1,0,0,0,0-1.789Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol